import React from 'react'
import { Button, Spinner, Menu, MenuItem } from '@blueprintjs/core';
import { Suggest } from '@blueprintjs/select';
import { observable, action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Api } from 'services/Api';
import axios from 'axios';
import debounce from 'services/debounce';

const SupplierRenderer = (supplier, { handleClick, modifiers }) => {
  return (
    <MenuItem
      active={modifiers.active}
      key={supplier.id}
      label={supplier.attributes.email}
      onClick={handleClick}
      text={supplier.attributes.name}
    />
  );
};

const ListRenderer = ({ items, itemsParentRef, query, renderItem, loading, failed }) => {
  const renderedItems = items.map(renderItem).filter(item => item != null);
  return (
    <Menu ulRef={itemsParentRef}>
      {
        failed && !loading && <MenuItem disabled={true} text={'Failed to load results :('} />
      }
      {
        loading && !failed && <MenuItem disabled={true} text={'Loading..'} label={<Spinner size={20}/>} />
      }
      {
        !loading && !failed && <MenuItem
                      disabled={true}
                      text={`Found ${renderedItems.length} clients matching "${query}"`}
                    />
      }
      {renderedItems}
    </Menu>
  );
}

@observer
class SupplierAutocomplete extends React.Component {

  @observable loading = true;
  @observable failed = false;
  @observable results = [];
  @observable selectedSupplier = null;

  componentDidUpdate(){
    if(this.props.value){
      this.selectedSupplier = this.props.value;
    }
  }

  

  componentDidMount() {
    let {
      selectedSupplierId
    } = this.props;

    
    if(selectedSupplierId) {     
      let promise = Api.post('/suppliers/search', { search: { term: '*', where: {id: selectedSupplierId},per_page: 50, page: 1, order: { name: 'asc' } } })
      promise.then(response => {       
        this.selectedSupplier = response.data.data[0];
      })
    }
    if(this.props.value){
      this.selectedSupplier = this.props.value;
    }
  }

  @action
  onQueryChange(query) {
    this.failed = false;
    this.loading = true;
    if (query === '') {
      return;
    }
    let promise = Api.post('/suppliers/search', { search: { term: query, per_page: 50, page: 1, order: { name: 'asc' } } })
    promise
      .then(this.onSuppliersLoad.bind(this))
      .catch(this.onSuppliersLoadFail.bind(this))
    return promise;
  }

  @action
  onSuppliersLoadFail(error) {
    if (axios.isCancel(error)) {
      this.loading = true;
    } else {
      this.loading = false;
      this.failed = true;
    }
  }

  @action
  onSuppliersLoad(response) {
    this.loading = false;
    this.failed = false;
    this.results = response.data.data;
  }

  @action
  onSupplierSelect(supplier) {
    this.selectedSupplier = supplier;
    this.props.onSupplierSelect(supplier);
  }

  @action
  clearSelectedSupplier() {
    this.selectedSupplier = null;
    this.props.onSupplierSelect(null);
  }

  render() {
    let {
      failed,
      results,
      onQueryChange,
      loading,
      onSupplierSelect,
      selectedSupplier,
      clearSelectedSupplier,
      props: {
        inputProps
      }
    } = this;
    
    return(
      <div>
        {
          selectedSupplier ? <Button 
              text={(this.selectedSupplier.attributes && this.selectedSupplier.attributes.name) || (this.selectedSupplier && this.selectedSupplier.name)} 
              rightIcon='cross'
              className="bp3-text-overflow"
              style={{display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center'}}
              onClick={clearSelectedSupplier.bind(this)}
            /> : <Suggest
              inputProps={{
                icon: 'cross',
                placeholder: 'Search supplier...',
                ...inputProps
              }}
              closeOnSelect={true}
              openOnKeyDown={true}
              resetOnQuery={true}
              resetOnSelect={true}
              popoverProps={{ minimal: true }}
              onQueryChange={debounce(onQueryChange.bind(this)).bind(this)}
              items={toJS(results)}
              itemRenderer={SupplierRenderer}
              itemListRenderer={(props) => <ListRenderer {...props} loading={loading} failed={failed} />}
              inputValueRenderer={(supplier) => supplier.attributes.name }
              onItemSelect={onSupplierSelect.bind(this)}
            />
        }
      </div>
    )
  }
}

SupplierAutocomplete.propTypes = {
  inputProps: PropTypes.object,
  onSupplierSelect: PropTypes.func.isRequired
}

export default SupplierAutocomplete;